module.exports = __webpack_public_path__ + "img/Galileo_Half_Light_675x315.3cd035da.png";